import { storage } from '@/utils/storage';
import { useMemo } from 'react';
import { useTradingCampaignVolume } from './useTradingCampaigns';

// Dữ liệu giả lập
export const CURRENT_VOLUME = 12000;
export const MAX_TARGET = 100000; // Đổi tên biến này để tránh nhầm lẫn với target động

// const initialMilestones = [
//     {
//         id: 1,
//         targetVolume: 5000,
//         startVolume: 0,
//         isCompleted: true,
//         isClaimed: false,
//         isStart: true,
//     },
//     {
//         id: 2,
//         targetVolume: 20_000,
//         startVolume: 5000,
//         isCompleted: false,
//         isClaimed: false,
//     },
//     {
//         id: 3,
//         targetVolume: 40_000,
//         startVolume: 20_000,
//         isCompleted: false,
//         isClaimed: false,
//     },
//     {
//         id: 4,
//         targetVolume: 80_000,
//         startVolume: 40_000,
//         isCompleted: false,
//         isClaimed: false,
//     },
//     {
//         id: 5,
//         targetVolume: 100_000,
//         startVolume: 80_000,
//         isCompleted: false,
//         isClaimed: false,
//     },
// ];

export function useGetDataVolume() {
    const {
        currentVolume,
        milestones: initialMilestones,
        isLoading,
        mutate,
    } = useTradingCampaignVolume();

    const { milestones, currentHighestTarget } = useMemo(() => {
        // 1. Map lại trạng thái isCompleted dựa trên volume hiện tại
        const mappedMilestones = initialMilestones?.map((item, index) => {
            // Check cache
            const cachedClaimed = storage.getWithExpiry<boolean>(
                `volume_claimed_${item.id}`
            );

            return {
                ...item,
                isCompleted: item.status === 3,
                isStart: index === 0,
                isClaimed: cachedClaimed === true || item.status === 5,
                startVolume: initialMilestones[index - 1]?.expected || 0,
            };
        });

        // 2. Tìm milestone ĐẦU TIÊN mà CHƯA hoàn thành (next goal)
        const nextMilestone =
            mappedMilestones?.find(
                (m) => Number(m.expected || 0) > currentVolume
            ) || mappedMilestones?.[mappedMilestones.length - 1];
        // 3. Xác định target hiển thị
        // - Nếu tìm thấy milestone chưa xong (VD: mốc 2), lấy target của nó (20,000).
        // - Nếu không tìm thấy (tức là đã xong hết 5 mốc), lấy mốc cuối cùng (MAX_TARGET).
        const target = nextMilestone
            ? nextMilestone.expected || 0
            : initialMilestones?.[0]?.info.task_params?.threshold || 0;

        return {
            milestones: mappedMilestones,
            currentHighestTarget: target,
        };
    }, [currentVolume, initialMilestones]);

    return {
        isLoading,
        milestones,
        currentVolume,
        currentHighestTarget,
        mutate, // Kết quả: 20,000 (với volume 12,000)
    };
}
